import { Children, isValidElement } from 'react'

export const pickChildrenByType = (children, component) => {
  return Children.toArray(children).filter(child => {
    return isValidElement(child) && child.type.name === component.name
  })
}
